import { Controller } from '@hotwired/stimulus'

import { type HandlesPercentile } from '../interfaces'

// Connects to data-controller="granular-allowances"
export default class extends Controller {
  static targets = [
    'percentileSlider',
    'percentileDisplay',
    'coveragePercentileField',
  ]

  declare readonly percentileSliderTarget: HTMLInputElement
  declare readonly percentileDisplayTargets: HTMLElement[]
  declare readonly coveragePercentileFieldTarget: HTMLInputElement

  private percentileConsumers: HandlesPercentile[] = []

  initialize () {
    this.percentileChanged()
  }

  granularAllowancesComparisonOutletConnected (outlet: HandlesPercentile, _e: HTMLDivElement): void {
    this.handleConnectedOutlet(outlet)
  }

  granularAllowancesMapOutletConnected (outlet: HandlesPercentile, _e: HTMLDivElement): void {
    this.handleConnectedOutlet(outlet)
  }

  granularAllowancesEstimateOutletConnected (outlet: HandlesPercentile, _e: HTMLDivElement): void {
    this.handleConnectedOutlet(outlet)
  }

  handleConnectedOutlet = (outlet: HandlesPercentile): void => {
    this.percentileConsumers.push(outlet)
    outlet.updatePercentile(parseInt(this.percentileSliderTarget.value))
  }

  percentileChanged = (): void => {
    this.updatePercentile()

    this.percentileConsumers.forEach(c => c.updatePercentile(parseInt(this.percentileSliderTarget.value)))
  }

  updatePercentile = (): void => {
    // Show the slider value in the big display
    this.percentileDisplayTargets.forEach(d => {
      d.innerHTML = this.percentileSliderTarget.value + '%'
    })

    // Update the hidden coverage percentile field in the form we submit
    this.coveragePercentileFieldTarget.value = this.percentileSliderTarget.value
  }
}
